import React from 'react';


const DashBoard = () => {


    
    
      return (
            <p>Dashboard</p>
      );
}
    


export default DashBoard;
